module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "suppliersidebar"
    }
  }, [_c('ul', [(_vm.issessionset) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/user"
    }
  }, [_vm._v("My Purchases")])], 1) : _vm._e(), _vm._v(" "), (_vm.issessionset) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/useraccount"
    }
  }, [_vm._v("Account Information")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cart"
    }
  }, [_vm._v("Cart")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aedd9d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserSidebar.vue
// module id = 143
// module chunks = 0